import React, { FC } from "react"
import { NavLink, withRouter, match } from "react-router-dom"
// import UIkit from "uikit"

interface Props<Params extends { [K in keyof Params]?: string } = {}> {
  history: any
  location: any
  match: match<Params>
  staticContext?: any
}

const Drawer: FC<Props> = ({ match: { path } }) => {
  const links = [
    { name: "feed", to: "feed", icon: "home" },
    { name: "charts", to: "charts", icon: "trending_up" },
    { name: "featured", to: "featured", icon: "star_outline" },
    { name: "explore", to: "discover", icon: "explore" },
    { name: "playlist", to: "playlist", icon: "subject" },
  ]

  // const closeDrawer = () => {
  //   const drawer = document.getElementById("drawer")
  //   UIkit.offcanvas(drawer).hide()
  // }

  return (
    <div id="drawer" uk-offcanvas="overlay: true">
      <div className="uk-offcanvas-bar uk-flex uk-flex-column uk-flex-center">
        <div className="links">
          {links &&
            links.map(({ name, to, icon }) => {
              return (
                <NavLink key={name} to={`/${to}`}>
                  <li className={`link ${path === "/" + to ? `active` : ``}`}>
                    <i className="material-icons-outlined md-24">{icon}</i>
                    <span>{name}</span>
                  </li>
                </NavLink>
              )
            })}
        </div>
      </div>
    </div>
  )
}

// <{match: RouteProps}>
export default withRouter<Props, any>(Drawer)
